<template>
  <vxe-layout-body style="margin-top: 2px">
    <a-space>
      <a-input v-model="filters['command.id']" :placeholder="$t('placeholder.commandId')" allowClear class="query" @pressEnter="fetch"/>
      <a-select v-model="filters['commandStatus']" :placeholder="$t('placeholder.commandStatus')" allowClear class="query" @search="fetch">
        <a-select-option v-for="d in commandStatus" :key="d.ordinal">{{ d.name }}</a-select-option>
      </a-select>
      <a-input v-model="filters['wave']" :placeholder="$t('placeholder.wave')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['order.no']" :placeholder="$t('placeholder.orderNo')" allowClear class="query" @pressEnter="fetch"/>
      <a-select v-model="filters['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storers" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-input v-model="filters['customer.name']" :placeholder="$t('placeholder.customerName')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['pickingOrder.no']" :placeholder="$t('placeholder.pickingOrderNo')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['container.no']" :placeholder="$t('placeholder.containerNo')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['loadingOrder.no']" :placeholder="$t('placeholder.loadingOrderNo')" allowClear class="query" @pressEnter="fetch"/>
    </a-space>
    <a-space>
      <a-input v-model="filters['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['item.barcode']" :placeholder="$t('placeholder.itemBarcode')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['storageRoom.name']" :placeholder="$t('placeholder.storageRoom')" allowClear class="query" @dblclick="onStorageRoomDoubleClicked" @pressEnter="fetch"/>
      <a-input v-model="filters['barcode.no']" :placeholder="$t('business.label.shipmentBarcode')" allowClear class="query" @pressEnter="fetch"/>
      <a-select v-model="filters['packType']" :placeholder="$t('placeholder.packType')" allowClear class="query" @search="fetch">
        <a-select-option v-for="d in packTypes" :key="d.ordinal">{{ d.name }}</a-select-option>
      </a-select>
      <a-select v-model="filters['legalAttribute.ids']" :maxTagCount=1 :placeholder="$t('placeholder.legalAttribute')" allowClear class="query" mode="tags">
        <a-select-option v-for="d in legalAttributes" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-select v-model="filters['storageRequest.ids']" :maxTagCount=1 :placeholder="$t('placeholder.storageRequest')" allowClear class="query" mode="tags">
        <a-select-option v-for="d in storageRequests" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-select v-model="filters['dosageForm.ids']" :maxTagCount=1 :placeholder="$t('placeholder.dosageForm')" allowClear class="query" mode="tags">
        <a-select-option v-for="d in dosageForms" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
    </a-space>
    <a-space>
      <a-input v-model="filters['location.no']" :placeholder="$t('placeholder.location')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['exchangePosition.no']" :placeholder="$t('placeholder.exchangePosition')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['seedingPosition.no']" :placeholder="$t('placeholder.seedingPosition')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['packingPosition.no']" :placeholder="$t('placeholder.packingPosition')" allowClear class="query" @pressEnter="fetch"/>
      <a-input v-model="filters['stagingPosition.no']" :placeholder="$t('placeholder.stagingPosition')" allowClear class="query" @pressEnter="fetch"/>
      <a-select v-model="filters['visualized']" :placeholder="$t('placeholder.visualized')" allowClear class="query">
        <a-select-option value="true">{{ $t('option.true') }}</a-select-option>
        <a-select-option value="false">{{ $t('option.false') }}</a-select-option>
      </a-select>
      <a-select v-model="filters['stagingCompleted']" :placeholder="$t('placeholder.stagingCompleted')" allowClear class="query">
        <a-select-option value="true">{{ $t('option.true') }}</a-select-option>
        <a-select-option value="false">{{ $t('option.false') }}</a-select-option>
      </a-select>
      <a-select v-model="filters['reviewed']" :placeholder="$t('placeholder.reviewed')" allowClear class="query">
        <a-select-option value="true">{{ $t('option.true') }}</a-select-option>
        <a-select-option value="false">{{ $t('option.false') }}</a-select-option>
      </a-select>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="fetch"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exp"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
      <vxe-column field="command.commandStatus" sortable title="business.label.commandStatus" width="100">
        <span slot-scope="{ row }">{{ commandStatus.find(item => item.ordinal === row.command.commandStatus).name }}</span>
      </vxe-column>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      <vxe-column field="dispatch.wave" sortable title="business.label.wave" width="100"/>
      <vxe-column field="barcode.no" sortable title="business.label.shipmentBarcode" width="100"/>
      <vxe-column field="storer.no" title="business.label.storerNo" width="80"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="customer.no" title="business.label.customerNo" width="100"/>
      <vxe-column field="customer.name" title="business.label.customerName" width="120"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="carrier.name" title="business.label.carrierName" width="120"/>
      <vxe-column field="carrier.expressCode" title="business.label.expressCode" width="120"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.innerFactor" title="business.label.innerFactor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo" width="150"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="location.no" title="business.label.locationNo" width="150"/>
      <vxe-column field="zone.no" title="business.label.zoneNo" width="150"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="150"/>
      <vxe-column field="checkoutLocation.no" title="business.label.checkoutLocation" width="150"/>
      <vxe-column field="checkoutContainer.no" title="business.label.checkoutContainer" width="150"/>
      <vxe-column field="container.no" title="business.label.sourceContainer" width="150"/>
      <vxe-column field="command.pickingMode" title="business.label.pickingMode" width="100">
        <span slot-scope="{ row }">{{ pickingModes.find(item => item.ordinal === row.command.pickingMode).name }}</span>
      </vxe-column>
      <vxe-column field="command.plannedQuantity" title="business.label.plannedQuantity" width="150"/>
      <vxe-column field="command.actualQuantity" title="business.label.actualQuantity" width="150"/>
      <vxe-column field="command.appendageSign" title="business.label.appendageSign" width="150">
        <span slot-scope="{ row }">{{ appendageSigns.find(item => item.ordinal === row.command.appendageSign).name }}</span>
      </vxe-column>
      <vxe-column field="command.packType" title="business.label.packType" width="120">
        <span slot-scope="{ row }">{{ packTypes.find(item => item.ordinal === row.command.packType).name }}</span>
      </vxe-column>
      <vxe-column field="pickingOrder.no" title="business.label.pickingOrderNo" width="150"/>
      <vxe-column field="picking.operator" title="business.label.picker" width="100"/>
      <vxe-column field="picking.startTime" sortable title="business.label.pickingStartTime" width="170"/>
      <vxe-column field="picking.finishTime" sortable title="business.label.pickingFinishTime" width="170"/>
      <vxe-column field="exchangePosition.no" title="business.label.exchangePosition" width="150"/>
      <vxe-column field="command.exchangingPositionAllocatedTime" sortable title="business.label.exchangingPositionAllocatedTime" width="170"/>
      <vxe-column field="exchangeContainer.no" title="business.label.exchangeContainer" width="150"/>
      <vxe-column field="exchange.exchanger" title="business.label.exchanger" width="100"/>
      <vxe-column field="exchange.exchangeTime" sortable title="business.label.exchangeTime" width="170"/>
      <vxe-column field="seedingPosition.no" title="business.label.seedingPosition" width="150"/>
      <vxe-column field="command.seedingPositionAllocatedTime" sortable title="business.label.seedingPositionAllocatedTime" width="170"/>
      <vxe-column field="seedingContainer.no" title="business.label.seedingContainer" width="150"/>
      <vxe-column field="seeding.operator" title="business.label.seeder" width="100"/>
      <vxe-column field="seeding.startTime" sortable title="business.label.seedingStartTime" width="170"/>
      <vxe-column field="command.visualReviewedTime" sortable title="business.label.visualReviewedTime" width="170"/>
      <vxe-column field="seeding.finishTime" sortable title="business.label.seedingFinishTime" width="170"/>
      <vxe-column field="packingPosition.no" title="business.label.packingPosition" width="150"/>
      <vxe-column field="command.packingPositionAllocatedTime" sortable title="business.label.packingPositionAllocatedTime" width="170"/>
      <vxe-column field="packing.operator" title="business.label.packer" width="100"/>
      <vxe-column field="packing.startTime" sortable title="business.label.packingStartTime" width="170"/>
      <vxe-column field="packing.finishTime" sortable title="business.label.packingFinishTime" width="170"/>
      <vxe-column field="stagingRegion.no" sortable title="business.label.stagingRegion" width="150"/>
      <vxe-column field="stagingPosition.no" title="business.label.stagingPosition" width="150"/>
      <vxe-column field="conveyor.no" title="business.label.conveyor" width="150"/>
      <vxe-column field="review.operator" title="business.label.stagingReviewer" width="100"/>
      <vxe-column field="review.startTime" sortable title="business.label.reviewStartTime" width="170"/>
      <vxe-column field="review.finishTime" sortable title="business.label.reviewFinishTime" width="170"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.activated" title="business.label.activated" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.supervised" title="business.label.supervised" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.scattered" title="business.label.scattered" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.visualized" title="business.label.visualized" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.autoSeeding" title="business.label.autoSeeding" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="command.autoPacking" title="business.label.autoPacking" width="70"/>
      <vxe-column field="command.id" title="business.label.commandId" width="180"/>
      <vxe-column field="command.commandGroup" title="business.label.commandGroup" width="180"/>
      <vxe-column field="command.task" title="business.label.taskId" width="180"/>
      <vxe-column field="pickingOrder.taskGroup" title="business.label.taskGroup" width="180"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 32px" @page-change="pageChange"/>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChanged"/>
  </vxe-layout-body>
</template>
<script>
import Vue from 'vue'
import { findAll, findEnum, findOne } from '@/api/Api'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ShipmentCommandQuery',
    components: {StorageRoomModal},
    data() {
      return {
        loading: false,
        page: 1,
        size: 20,
        contentSize: 0,
        data: [],
        storers: [],
        packTypes: [],
        commandStatus: [],
        pickingModes: [],
        appendageSigns: [],
        legalAttributes: [],
        storageRequests: [],
        dosageForms: [],
        visualized: [],
        stagingCompleted: [],
        reviewed: [],
        filters: {
          'order.no': '',
          'command.id': '',
          packType: undefined,
          commandStatus: undefined,
          'item.no': '',
          'item.barcode': '',
          'container.no': '',
          'pickingOrder.no': '',
          'storageRoom.name': '',
          wave: '',
          'barcode.no': '',
          'storer.id': undefined,
          'customer.name': '',
          'location.no': '',
          'seedingPosition.no': '',
          'exchangePosition.no': '',
          'packingPosition.no': '',
          'stagingPosition.no': '',
          'loadingOrder.no': '',
          visualized: undefined,
          stagingCompleted: undefined,
          reviewed: undefined
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.75)
      }
    },
  created() {
      findAll('storerFactory', {available: true}).then(res => {
        if (res.success) {
          this.storers = res.result
        }
      })
      findEnum('PackType').then(res => {
        if (res.success) {
          this.packTypes = res.result
        }
      })
      findEnum('CommandStatus').then(res => {
        if (res.success) {
          this.commandStatus = res.result
        }
      })
      findEnum('PickingMode').then(res => {
        if (res.success) {
          this.pickingModes = res.result
        }
      })
      findEnum('AppendageSign').then(res => {
        if (res.success) {
          this.appendageSigns = res.result
        }
      })
      findOne('fieldFactory', {no: 'LEGAL_ATTR'}).then(res => {
        if (res.success) {
          this.legalAttributes = res.result.dictionaries
        }
      })
      findOne('fieldFactory', {no: 'STORAGE_REQUEST'}).then(res => {
        if (res.success) {
          this.storageRequests = res.result.dictionaries
        }
      })
      findOne('fieldFactory', {no: 'DOSAGE_FORM'}).then(res => {
        if (res.success) {
          this.dosageForms = res.result.dictionaries
        }
      })
    },
    methods: {
      onStorageRoomDoubleClicked() {
        this.$refs.storageRoomModal.open({available: true, physical: true})
      },
      onStorageRoomChanged(value) {
        this.filters['storageRoom.name'] = value.length === 0 ? '' : value[0].name
      },
      fetch() {
        this.loading = true
        const args = Object.assign({}, this.filters)
        findAll('shipmentCommandFactory', args, this.page, this.size).then(res => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
          }
        }).finally(() => this.loading = false)
      },
      reset() {
        this.filters = {
          'order.no': '',
          'command.id': '',
          packType: undefined,
          commandStatus: undefined,
          'item.no': '',
          'item.barcode': '',
          'container.no': '',
          'pickingOrder.no': '',
          'storageRoom.name': '',
          wave: '',
          'barcode.no': '',
          'storer.id': undefined,
          'customer.name': '',
          'location.no': '',
          'seedingPosition.no': '',
          'exchangePosition.no': '',
          'packingPosition.no': '',
          'stagingPosition.no': '',
          'loadingOrder.no': '',
          visualized: undefined,
          stagingCompleted: undefined,
          reviewed: undefined,
          legalAttribute: false,
          storageRequest: false,
          dosageForm: false
        }
        this.data = []
        this.visualized = []
        this.stagingCompleted = []
        this.reviewed = []
      },
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.fetch()
      },
      exp() {
        this.$refs.table.openExport()
      }
    }
  }
</script>

<style scoped>
  .query {
    width: 180px;
  }
</style>